<template>
	<div id="dataStatistics">
		<div class="layout-content">
			<!-- 标题面包屑 -->
			<div class="layout-content-title">
				<div class="breadcrumb">
					<svg class="iconpark-icon" @click="onBack"><use href="#fanhui"></use></svg>
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item @click="onBack">{{ backTitle }}</el-breadcrumb-item>
						<el-breadcrumb-item>数据统计</el-breadcrumb-item>
					</el-breadcrumb>
					<!-- <div class="project-title" v-text="title" /> -->
				</div>
			</div>
			<!-- 列表数据 -->
			<div class="layout-container">
				<!-- 所有数据导航栏 -->
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="所有数据" name="first">
						<!-- <div v-if="hidden" class="tips">最多只能选择5项</div> -->
						<div class="handle-bar">
							<!-- 下拉框 -->
							<div class="search-box">
								<label>来源：</label>
								<el-select v-model="platformOrigin" class="select-box" placeholder="请选择">
									<el-option label="全部" value="" />
									<el-option label="映目直播" :value="0" />
									<el-option label="映目云摄影" :value="1" />
								</el-select>
								<label>关键词：</label>
								<el-input v-model="activityTitle" placeholder="直播间/活动名称或ID查询" />
								<label>时间：</label>
								<el-date-picker
									v-model="queryDate"
									type="datetimerange"
									value-format="yyyy-MM-dd HH:mm:ss"
									range-separator="-"
									start-placeholder="开始时间"
									end-placeholder="结束时间"
								>
								</el-date-picker>
								<el-button type="primary" class="search" @click="search"> 搜索 </el-button>
							</div>
						</div>
						<div class="handleBtn">
							<div class="handleBtnBox">
								<div v-if="!oldMark && type == 0" class="statusList">
									<div
										v-for="item in statusList"
										:key="item.value"
										:class="['statusItem', { active: item.value === pagesList.auditStatus }]"
										@click="onStatusClick(item.value)"
									>
										{{ item.label }}（{{ count[item.countKey] }}）
									</div>
								</div>
							</div>
							<div class="handleBtnBox">
								<el-button type="primary" @click="deletes">
									<svg class="iconpark-icon"><use href="#shanchu"></use></svg>批量删除
								</el-button>
								<el-button v-if="oldMark == '1'" type="primary" @click="educe">
									<svg class="iconpark-icon"><use href="#daoru"></use></svg>导出
								</el-button>
								<form
									v-if="oldMark == '0'"
									ref="exportForm"
									class="export_form"
									:action="exportUrl"
									method="post"
									target="_blank"
								>
									<input class="token" type="text" name="token" :value="exportToken" />
									<input class="export_btn" :disabled="!exportToken" type="submit" value="导出数据" />
								</form>
								<el-button v-if="oldMark == '0'" type="primary" @click="onExportSubmit">
									<svg class="iconpark-icon"><use href="#daoru"></use></svg>导出
								</el-button>
							</div>
						</div>
						<!-- </el-tooltip> -->
						<!-- 列表内容 -->
						<div class="dataInfo">
							<!-- <el-table
								ref="multipleTable"
								:data="infoListAnswer"
								tooltip-effect="dark"
								style="width: 100%"
								@selection-change="handleSelectionChange"
							>
								<el-table-column type="selection" width="55" />
								<el-table-column
									prop="createDate"
									label="提交时间"
									width="180"
									:formatter="formatterDate"
								/>
								<el-table-column
									v-for="(item, index) in infoListOptions"
									:key="index"
									:prop="oldMark ? 'answerDetail.' + item.id : 'answerArr.' + item.id"
									:label="item.title"
									show-overflow-tooltip
								/>
								<el-table-column fixed="right" label="操作" width="160">
									<template slot-scope="scope">
										<el-button
											type="text"
											size="small"
											class="details"
											@click="detaiils(scope.row)"
										>
											查看详情
										</el-button>
									</template>
								</el-table-column>
							</el-table> -->

							<el-table
								ref="multipleTable"
								:data="infoListAnswer"
								tooltip-effect="dark"
								style="width: 100%"
								@selection-change="handleSelectionChange"
							>
								<el-table-column type="selection" min-width="50"> </el-table-column>
								<el-table-column label="提交时间" min-width="140" :formatter="formatterDate">
								</el-table-column>
								<el-table-column label="直播间名称" min-width="140">
									<template slot-scope="scope">
										{{
											scope.row.activityName ||
											scope.row.gatherName ||
											scope.row.activityTitle ||
											scope.row.gatherTitle
										}}
									</template>
								</el-table-column>
								<el-table-column label="用户头像" min-width="140">
									<template slot-scope="scope">
										<img class="wxAvatar" :src="scope.row.avatarUrl" alt="" />
									</template>
								</el-table-column>
								<el-table-column label="用户昵称" min-width="140" prop="nickname"> </el-table-column>
								<el-table-column label="操作" min-width="240" align="right">
									<template slot-scope="scope">
										<el-link type="primary" :underline="false" @click="onInfoClick(scope.row)"
											>查看详情</el-link
										>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<!-- 分页 -->
						<div class="pages">
							<el-pagination
								:current-page.sync="pagesList.currentPage"
								:page-size="pagesList.pageSize"
								:total="pagesList.total"
								layout=" prev, pager, next, sizes,  jumper"
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
							/>
						</div>
					</el-tab-pane>
					<!-- 项目统计导航栏 -->
					<el-tab-pane label="项目统计" name="second">
						<!-- 项目统计页面导出按钮 -->
						<div class="handleBtn">
							<el-button type="primary" @click="derive">
								<svg class="iconpark-icon"><use href="#daoru"></use></svg>导出
							</el-button>
						</div>
						<div id="projectStatistics">
							<div v-if="infoListAnswer.length != 0 && projectList.length > 0" id="project_content">
								<question-item
									v-for="(item, index) in projectList"
									:key="index"
									:item="item"
									class="answer-box"
									@change-type="onTypeChange"
								/>
							</div>
							<div v-else-if="isloading" />
							<div v-else class="noStatistics">
								<div class="pics">
									<svg class="icon icon3" aria-hidden="true">
										<use xlink:href="#icon-xiangmukongzhuangtai" />
									</svg>
									<p class="text">暂无统计数据</p>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<!-- 导出弹框-->
		<div class="pdfExports">
			<el-dialog :visible.sync="centerDialogVisible" title="导出PDF" width="30%" center>
				<p class="text">请选择将要导出的统计图</p>
				<div class="questionList">
					<el-checkbox-group v-model="checkedList">
						<el-checkbox
							v-for="(item, index) in projectList"
							:key="index"
							:label="item.id"
							:disabled="item.type !== 1 && item.type !== 2"
						>
							{{ item.title }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button
						:class="checkedList.length == 0 ? 'el-button--primary' : 'exportButton'"
						:disabled="checkedList.length == 0"
						type="primary"
						@click="exportPsd"
						>导出</el-button
					>
				</span>
			</el-dialog>
		</div>

		<survey-watch-info ref="surveyWatchInfo" :old-mark="oldMark" :survey-id="surveyId" />
	</div>
</template>
<script>
import { surveyAnswer, answerReport, exportFile } from '@/services';
import { urlfull } from '@/services/http.js';
import questionItem from './questionList/questionItem.vue';
import { formatDate } from '@/plugins/dateFormatter';
import { mapActions, mapState } from 'vuex';
import surveyWatchInfo from './surveyWatchInfo.vue';
const statusList = [
	{
		label: '全部',
		value: '',
		countKey: 'all',
	},
	{
		label: '报名成功',
		value: 0,
		countKey: 'success',
	},
	{
		label: '待审核',
		value: 1,
		countKey: 'noAudit',
	},
	{
		label: '已拒绝',
		value: 2,
		countKey: 'refuse',
	},
];
export default {
	components: {
		questionItem,
		surveyWatchInfo,
	},
	data() {
		return {
			queryDate: [],
			queryEndDate: '',
			queryStartDate: '',
			activityTitle: '',
			platformOrigin: '',
			activeName: 'first',
			surveyId: this.$route.params.id,
			title: this.$route.params.title,
			projectList: [],
			projectListTypeMap: {},
			infoListOptions: [],
			infoListAnswer: [],
			innerVisible: false,
			checkedList: [],
			centerDialogVisible: false,
			pagesList: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
				auditStatus: '',
			},
			delteArray: [],
			hidden: false,
			isloading: true,
			oldMark: false, // 报名表版本 true 旧版，false 新版
			exportUrl: null,

			statusList,
			count: {
				all: 0,
				noAudit: 0,
				refuse: 0,
				success: 0,
			},
		};
	},
	computed: {
		apiVersion() {
			return this.oldMark ? surveyAnswer : answerReport;
		},
		...mapState({
			exportToken: (state) => state.exportFile.token,
		}),
        type() {
            return Number(this.$route.query.type);
        },
        backTitle() {
            switch (this.type) {
                case 0:
                    return '报名表列表';
                case 2:
                    return '调查问卷列表';
                default:
                    return '调查问卷列表';
            }
        },
	},
	mounted() {
		this.oldMark = Number(this.$route.query.oldMark) ? true : false;
		this.getAllDataStatistics();
		this.getQueryAnswer(1);
		this.getToken();
	},
	methods: {
		...mapActions({
			getToken: 'exportFile/getToken',
		}),
		to(routeInfo) {
			this.$router.push(routeInfo);
		},
        //返回
        onBack() {
            const type = this.type;
            switch (type) {
                case 0:
                    this.to({
                        name: 'signList',
                    });
                    break;
                case 2:
                    this.to({
                        name: 'question',
                    });
                    break;
                default:
                    this.to({
                        name: 'question',
                    });
                    break;
            }
        },
		getExportUrl() {
			if (this.queryDate && this.queryDate.length) {
				this.queryStartDate = this.queryDate[0] ? this.queryDate[0] : '';
				this.queryEndDate = this.queryDate[1] ? this.queryDate[1] : '';
			} else {
				this.queryStartDate = '';
				this.queryEndDate = '';
			}
			this.exportUrl = exportFile.exportAnswer(
				this.surveyId,
				+new Date(this.queryStartDate),
				+new Date(this.queryEndDate),
				this.activityTitle,
				this.platformOrigin,
				this.pagesList.auditStatus
			);
		},
		onExportSubmit() {
			this.$confirm('确认导出全部数据吗？', '确认导出', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				center: true,
			})
				.then(() => {
					this.getExportUrl();
					this.$refs.exportForm.action = this.exportUrl;
					this.$refs.exportForm.submit();
				})
				.catch(() => {});
		},
		//tab 切换
		handleClick(val) {
			if (val.name == 'second') {
				const apiObj = this.oldMark ? surveyAnswer : answerReport;
				apiObj.getProjectStatistics(this.surveyId).then(({ ok, data }) => {
					if (ok) {
						this.projectList = data.data.answerStatistics;
						this.isloading = false;
						this.projectList.forEach((item) => {
							this.projectListTypeMap[item.id] = 2;
						});
					}
				});
			}
		},
		//导出
		exportPsd() {
			const ids = this.checkedList
				.map((item) => {
					const stat = this.projectListTypeMap[item];
					return `${item}-${stat}`;
				})
				.join(',');
			const name = '统计.pdf';
			const u = urlfull(`/surveyAnswer/export?surveyId=${this.surveyId}&ids=${ids}`);
			const url = `https://ssr.ourwill.cn/pdf/${btoa(u)}.pdf?name=${name}&margin=0,30`;
			window.open(url);
		},
		//搜索
		search() {
			this.getQueryAnswer(1);
			// for (const key in this.infoListOptions) {
			// 	var item = this.infoListOptions[key];
			// 	item.checked = item.value;
			// }
		},
		//刷新
		updates() {
			this.getQueryAnswer(this.pagesList.currentPage, true);
		},
		//导出数据统计
		educe() {
			if (this.queryDate && this.queryDate.length) {
				this.queryStartDate = this.queryDate[0] ? this.queryDate[0] : '';
				this.queryEndDate = this.queryDate[1] ? this.queryDate[1] : '';
			} else {
				this.queryStartDate = '';
				this.queryEndDate = '';
			}
			this.$confirm('确认导出全部数据吗？', '确认导出', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				center: true,
			})
				.then(() => {
					const u = urlfull(
						`/surveyAnswer/exportExcel/?surveyId=${this.surveyId}&endTime=${+new Date(
							this.queryEndDate
						)}&startTime=${+new Date(this.queryStartDate)}&activityTitle=${
							this.activityTitle
						}&platformOrigin=${this.platformOrigin}`
					);
					window.open(u);
				})
				.catch((err) => {
					console.log(err);
					this.$message({
						type: 'info',
						message: '已取消导出',
					});
				});
		},
		//导出项目统计
		//1 饼 2 柱 3 条
		derive() {
			this.centerDialogVisible = true;
		},
		// even(list) {
		// 	return list.filter(function(item) {
		// 		return item.checked;
		// 	});
		// },
		//详情
		detaiils(row) {
			console.log(row);
			const id = this.surveyId;
			const source = row.source || row.id;
			this.$router.push({
				path: `/questionnaireDataStatisticsEdit/${id}/${source}/show/${this.$route.query.oldMark}`,
			});
		},
		//页码
		handleCurrentChange(pages) {
			this.getQueryAnswer(pages);
		},
		onStatusClick(auditStatus) {
			this.pagesList.auditStatus = auditStatus;
			this.pagesList.currentPage = 1;
			this.getQueryAnswer(this.pagesList.currentPage);
		},
		// //每页size-change
		handleSizeChange(val) {
			this.pagesList.pageSize = val;
			this.getQueryAnswer(this.pagesList.currentPage);
		},
		//获取数据统计
		getAllDataStatistics() {
			surveyAnswer.getDataStatistics(this.surveyId).then(({ ok, data }) => {
				if (ok) {
					this.infoListOptions = data.data.map((item, index) => {
						return {
							id: item.id,
							title: item.title,
						};
					});
				}
			});
		},
		async getQueryAnswer(currentPage, isUpdate) {
			if (this.queryDate && this.queryDate.length) {
				this.queryStartDate = this.queryDate[0] ? this.queryDate[0] : '';
				this.queryEndDate = this.queryDate[1] ? this.queryDate[1] : '';
			} else {
				this.queryStartDate = '';
				this.queryEndDate = '';
			}
			const body = {
				startTime: +new Date(this.queryStartDate) ? +new Date(this.queryStartDate) : null,
				endTime: +new Date(this.queryEndDate) ? +new Date(this.queryEndDate) : null,
				platformOrigin: this.platformOrigin,
				activityTitle: this.activityTitle,
			};
			if (this.pagesList.auditStatus !== '') {
				body.auditStatus = this.pagesList.auditStatus;
			}
			const params = {
				pageNum: currentPage,
				pageSize: this.pagesList.pageSize ? this.pagesList.pageSize : 10,
			};
			const { data, ok } = await this.apiVersion.getQueryAnswer(this.surveyId, body, params);
			if (!ok) {
				return;
			}
			if (this.oldMark) {
				const { pageNum, pageSize, total } = data.data;
				this.infoListAnswer = data.data.data;
				this.pagesList.currentPage = pageNum;
				this.pagesList.pageSize = pageSize;
				this.pagesList.total = total;
				this.listType = 1;
			} else {
				// 新版 api
				const { current, size, total, records } = data.data.answerReportPage;
				this.infoListAnswer = records;
				this.pagesList.currentPage = current;
				this.pagesList.pageSize = size;
				this.pagesList.total = total;
				this.listType = 1;
				this.count = data.data.count;
			}
			isUpdate &&
				this.$message({
					type: 'success',
					message: '刷新成功',
				});
		},
		//获取答案列表
		// getAnswers(surveyId, currentPage, pageSize) {
		// 	surveyAnswer.getDataAnswer(surveyId, currentPage, pageSize).then(({ ok, data }) => {
		// 		if (ok) {
		// 			this.infoListAnswer = data.data.data;
		// 			this.pagesList.currentPage = data.data.pageNum;
		// 			this.pagesList.pageSize = data.data.pageSize;
		// 			this.pagesList.total = data.data.total;
		// 		}
		// 	});
		// },
		//删除||批量删除
		deletes() {
			this.$confirm('确认删除已选择的数据吗?', '确认删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			})
				.then(() => {
					this.batchDelete();
				})
				.catch((err) => {
					console.log(err);
					this.$message({
						type: 'info',
						message: '已取消删除',
					});
				});
		},
		//删除答案的数组
		handleSelectionChange(val) {
			this.delteArray = val.map((item) => item.source || item.id);
		},
		//批量删除数据
		async batchDelete() {
			console.log(this.delteArray);
			const { data, ok } = this.oldMark
				? await surveyAnswer.batchDeleting(this.delteArray)
				: await answerReport.batchDeleting(this.surveyId, this.delteArray);
			if (ok) {
				let source = this.infoListAnswer.filter((item) => {
					return !this.delteArray.some((del) => {
						return del == item.source || del == item.id;
					});
				});
				this.infoListAnswer = source;
				this.$message.success(data.msg);
			} else {
				this.$message.error('没有可删除的数据');
			}
		},
		// checkboxChange(item) {
		// 	if (item.value) {
		// 		let source = this.infoListOptions.filter(opt => {
		// 			return opt.value;
		// 		});
		// 		if (source.length > 5) {
		// 			item.value = false;
		// 			this.hidden = true;
		// 		}
		// 	}
		// },

		onTypeChange(id, str) {
			this.projectListTypeMap[id] = str;
			console.log(this.projectListTypeMap[id], 998);
		},
		formatterDate(row, column) {
			return formatDate(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
		},

		onInfoClick(item) {
			this.$refs.surveyWatchInfo.show(item);
		},
	},
};
</script>
<style lang="less">
.el-dialog__headerbtn .el-dialog__close {
	color: #333;
	font-weight: bold;
}
.el-table td,
.el-table th {
	padding: 10px 0 !important;
}
.pdfExports {
	.el-dialog--center {
		width: 418px;
		height: 428px;
		color: #333;
		font-weight: 600px;
		.el-dialog__header {
			text-align: left;
			padding: 20px 20px 0px 20px;
		}
		.el-dialog__body {
			width: 100%;
			padding: 25px 0 40px 0;
			.text {
				text-indent: 25px;
				margin: 0 0 24px 0;
				line-height: 22px;
			}
		}

		.questionList::-webkit-scrollbar {
			width: 10px;
			height: 80px;
			background-color: #f4f4f4;
		}
		.questionList::-webkit-scrollbar-track-piece {
			background-color: #f4f4f4;
		}
		.questionList::-webkit-scrollbar-thumb {
			border-radius: 10px;
		}
		.questionList {
			width: 100%;
			height: 212px;
			overflow-y: auto;
			overflow-x: hidden;
			padding: 11px 0px 11px 25px;
			box-sizing: border-box;
			background-color: #f4f7fa;
			.el-checkbox {
				width: 360px;
				line-height: 24px;
				display: flex;
				flex: 1;
				.el-checkbox__input {
					padding: 5px 10px 5px 0px;
				}
			}
			.el-checkbox__label {
				line-height: 24px;
				word-break: break-all;
				word-wrap: break-word;
				white-space: normal;
				padding-left: 0;
			}
		}
		.el-dialog__footer {
			text-align: right;
			.el-button {
				width: 90px;
				height: 32px;
				line-height: 32px;
				border: 1px solid #b8bcc4;
				padding: 0;
				box-sizing: border-box;
			}
			.el-button--primary {
				background-color: #c8cbd0;
				border: 1px solid #c8cbd0;
			}
			.exportButton {
				background-color: #2c7dfa;
				border: 1px solid #2c7dfa;
			}
		}
	}
}

#dataStatistics {
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(242, 243, 245, 1);
	overflow: auto;
	.pane {
		background-color: #fff;
		border: 1px solid #d8dbe0;
		width: 18px;
		height: 18px;
	}
	.cell {
		text-align: center;
	}
	.el-table--enable-row-hover .el-table__body tr:hover > td {
		background-color: #f5f7fa !important;
	}
	.el-tag {
		display: none;
	}
	.hover-row {
		background-color: #f4f7fa;
	}
	.layout-content {
		border-radius: 4px;
		.layout-content-title {
			position: relative;
			z-index: 10;
			height: 64px;
			padding: 16px 16px 16px 24px;
			font-size: 14px;
			box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.breadcrumb {
				display: flex;
				align-items: center;
				.iconpark-icon {
					font-size: 20px;
					margin-right: 16px;
					cursor: pointer;
				}
				.el-breadcrumb__inner {
					color: rgba(29, 33, 41, 1);
					font-size: 18px;
					&.is-link {
						color: rgba(134, 144, 156, 1);
						font-weight: normal;
					}
				}
				.el-breadcrumb__separator {
					font-size: 16px;
				}
			}
			.project-title {
				text-align: right;
				color: #2b313c;
				font-weight: 600;
				width: 150px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
	.layout-container {
		position: relative;
		margin: 16px;
		.tips {
			color: #db1f1f;
			font-size: 14px;
			margin-left: 22px;
		}
		.el-tabs {
			width: 100%;
			.el-tab-pane {
				width: 100%;
			}
			.el-tabs__nav {
				padding-left: 16px;
			}
			.el-tabs__header {
				margin: 0;
				background-color: #fff;
				box-shadow: 0px 1px 0px rgba(229, 230, 235, 1);
			}
			.el-tabs__content {
				padding: 0;
				background: transparent;
			}
			.el-tabs__active-bar {
				margin-left: 16px;
			}
		}
		.handle-bar {
			height: 80px;
			padding: 24px 22px;
			position: relative;
			font-size: 14px;
			line-height: 34px;
			background-color: #fff;
			.search-box {
				display: flex;
				white-space: nowrap;
				label {
					margin-left: 32px;
					color: rgba(29, 33, 41, 1);
				}
				.line {
					display: inline-block;
					color: #b8bcc4;
					padding: 0 8px;
				}
				.el-input {
					width: 250px;
				}
				.el-input__inner {
					height: 32px;
				}
			}
			.el-range-separator {
				line-height: 26px;
			}
			.search {
				width: 70px;
				height: 34px;
				line-height: 34px;
				padding: 0;
				margin-left: 16px;
				border: none;
				background: rgba(52, 145, 250, 1);
				flex-shrink: 0;
			}
			.el-input {
				max-width: 250px;
			}
			.el-input__icon,
			.el-input__inner {
				height: 34px !important;
				line-height: 34px;
				color: #999999;
			}
		}
		.handleBtn {
			height: 32px;
			margin-top: 16px;
			color: #5d6574;
			display: flex;
			justify-content: space-between;
			.handleBtnBox {
				display: flex;
				height: 32px;
				.el-button {
					span {
						line-height: 32px;
					}
				}
			}
			.statusList {
				display: flex;
				align-items: center;
				.statusItem {
					padding-left: 16px;
					margin-right: 24px;
					font-size: 14px;
					color: rgba(78, 89, 105, 1);
					cursor: pointer;
					&.active {
						font-weight: bold;
						color: rgba(22, 93, 255, 1);
					}
				}
			}
			.export_form {
				display: none;
			}
			.el-button {
				padding: 0 8px;
				> span {
					display: flex;
					align-items: center;
				}
				margin-right: 12px;
			}
			.iconpark-icon {
				margin-right: 4px;
				font-size: 16px;
				fill: #f4f4f4;
			}
		}
		.dataInfo {
			margin-top: 16px;
			padding: 22px 24px;
			background: rgba(255, 255, 255, 1);
			.el-table__body-wrapper .is-leaf {
				border-bottom: 1px solid #ebeef5;
			}
			.el-table__header .is-leaf {
				border-bottom: none;
			}
			.el-table__header-wrapper {
				border-bottom: 1px solid #ebeef5 !important;
			}
			tbody {
				.cell {
					.el-button {
						text-align: center;
						width: 100px;
						height: 24px;
						padding: 0;
						span {
							width: 100px;
							display: block;
							line-height: 24px;
						}
					}
				}
			}
			thead {
				color: #333;
				th.el-table__cell {
					background: rgba(242, 243, 245, 1);
				}
			}
			.details {
				width: 30px;
			}
			.el-checkbox__inner {
				border: 1px solid #d8dbe0;
				width: 18px;
				height: 18px;
				&::after {
					left: 6px;
					top: 3px;
				}
			}
			.el-button {
				margin-left: 0;
				line-height: 12px;
				height: 12px;
			}

			.wxAvatar {
				width: 50px;
				height: 50px;
			}
		}
		.derive {
			padding: 0 8px;
			height: 32px;
			margin-top: 14px;
			line-height: 34px;
			font-size: 14px;
			cursor: pointer;
			background-color: #1091ff;
			color: #fff;
			border-radius: 4px;
			.icon {
				margin: 8px 9px 0px 16px;
				width: 18px;
				height: 18px;
			}
		}
		.el-pagination {
			.btn-prev,
			.btn-next,
			.el-pager li {
				border: 1px solid #d9d9d9;
				border-radius: 4px;
				box-sizing: border-box;
				min-width: 28px;
			}
			.btn-prev {
				margin-right: 4px;
				padding-right: 4px;
				&:hover {
					color: #1890ff;
					border: 1px solid #1890ff;
				}
			}
			.btn-next {
				padding-left: 4px;
				&:hover {
					color: #1890ff;
					border: 1px solid #1890ff;
				}
			}
			.el-pager {
				li {
					margin-right: 4px;
					&:hover {
						color: #1890ff;
						border: 1px solid #1890ff;
					}
					&.active {
						color: #1890ff;
						border: 1px solid #1890ff;
					}
				}
			}
		}
	}
}
// .pages .el-pagination button, .el-pagination span:not([class*=suffix]){
//   display: none;
// }
.el-select-dropdown {
	width: 278px !important;
}
.el-checkbox__label {
	max-width: 200px;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
	display: none;
	content: '' !important;
}
#projectStatistics {
	padding: 24px;
	background: rgba(255, 255, 255, 1);
	margin-top: 16px;
}
.questionList {
	.el-checkbox + .el-checkbox {
		margin-left: 0 !important;
	}
	#project_content {
		.answer-box {
			width: 100%;
		}
		#projectStatistics {
			.noStatistics {
				display: flex;
				justify-content: center;
				align-items: center;
				margin: 0 auto;
				width: 100%;
				min-height: 800px;
			}
			.pics {
				width: 190px;
				.icon {
					width: 165px;
					height: 155px;
				}
			}
			.text {
				margin-left: 40px;
				bottom: 5px;
				left: 6px;
				color: #b8bcc4;
			}
		}
	}
}
</style>
